// extracted by mini-css-extract-plugin
module.exports = {"lottieLoaderBlock":"style_lottieLoaderBlock__k-61P","lottieLoader":"style_lottieLoader__2bnSD"};